import { render, staticRenderFns } from "./googleBtn.vue?vue&type=template&id=70912df6"
import script from "./googleBtn.vue?vue&type=script&lang=js"
export * from "./googleBtn.vue?vue&type=script&lang=js"
import style0 from "./googleBtn.vue?vue&type=style&index=0&id=70912df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports